import { Check } from "@mui/icons-material";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Avatar, Box, Typography } from "@mui/material";
import React, { useState } from "react";
import VerificationIco from "../../../../assets/icons/VerificationIco";
import Breadcrumbs from "../../../../component/Breadcrumbs";
import IgnitePopup from "./IgnitePopup";
import ProposalGeneratorReview from "./ProposalGeneratorReview";
import SubmitBidPopup from "./SubmitBidPopup";

const steps = [
  // { id: "Step 1", label: "View Sow" },
  { id: "Step 2", label: "Generate Proposal" },
  { id: "Step 3", label: "Enterprise Approval" },
  // { id: "Step 4", label: "Final Review" },
  { id: "Step 5", label: "Submit Proposal" },
];

export default function StepperComponent() {
  const [activeStep, setActiveStep] = useState(0);
  const [hyperDialogOpen, setHyperDialogOpen] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });
  const [activate, setActivate] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });

  // const handleNext = (allVerified) => {
  //   if (activeStep === steps.length - 1) {
  //     //   handleGenerateBrief();
  //   } else {
  //     if (!allVerified) {
  //       alert("You have not verified all the information in the Checklist.");
  //       return;
  //     }
  //     setActiveStep((prev) => prev + 1);
  //   }
  // };

  const handleNext = (allVerified) => {
    console.log("Received Value in handleNext:", typeof allVerified);
    if (activeStep === 0 && !allVerified) {
      setHyperDialogOpen((prev) => ({
        ...prev,
        activateOpen: true,
      }));
      // alert("You have not verified all the information in the Checklist.");
      return;
    }

    if (activeStep === steps.length - 1) {
      // handleGenerateBrief();
      setActivate((prev) => ({
        ...prev,
        activateOpen: true,
      }));
      setActiveStep((prev) => prev + 1);
      return;
    }

    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));

  const handleHyperPopupClose = () => {
    setHyperDialogOpen({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };

  const handlePopupClose = () => {
    setActivate({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        width: "100%",
        padding: "2rem",
      }}
    >
      <Box>
        <Breadcrumbs
          breadCrumbData={[
            { title: "Sow Invites", navigate: -1 },
            { title: "Project Atlantis", active: true },
          ]}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {steps.map((step, index) => (
          <>
            <Box
              key={step.id}
              display="flex"
              alignItems="center"
              flexDirection="column"
              gap="8px"
            >
              <Box display="flex" alignItems="center" gap={1}>
                {index < activeStep ? (
                  <Avatar sx={{ bgcolor: "#47CD89", width: 30, height: 30 }}>
                    <Check sx={{ color: "white", fontSize: 20 }} />
                  </Avatar>
                ) : index === activeStep ? (
                  <Avatar sx={{ bgcolor: "#EBE1F9", width: 30, height: 30 }}>
                    <RadioButtonCheckedIcon
                      sx={{ color: "#7F56D9", fontSize: 20 }}
                    />
                  </Avatar>
                ) : (
                  <Avatar sx={{ bgcolor: "#EAECF0", width: 30, height: 30 }}>
                    <RadioButtonUncheckedIcon
                      sx={{ color: "#EAECF0", fontSize: 20 }}
                    />
                  </Avatar>
                )}
              </Box>

              <Typography
                sx={{ color: "#101828", fontSize: "14px", fontWeight: 600 }}
              >
                {step.label}
              </Typography>

              <Typography
                sx={{
                  color:
                    index < activeStep
                      ? "#17B26A"
                      : index === activeStep
                      ? "#7F56D9"
                      : "#475467",
                  fontSize: 14,
                }}
              >
                {index < activeStep
                  ? "Completed"
                  : index === activeStep
                  ? "In Progress"
                  : "Pending"}
              </Typography>
            </Box>

            {index < steps.length - 1 && (
              <Box
                sx={{
                  width: "290px",
                  height: "2px",
                  bgcolor: index < activeStep ? "#00C853" : "#E0E0E0",
                  marginTop: "8px",
                }}
              />
            )}
          </>
        ))}
      </Box>

      <Box sx={{ width: "100%" }}>
        <ProposalGeneratorReview
          edited={false}
          handleGenerateProposal={handleNext}
          isLegal={activeStep === 1 ? true : false}
          isReview={activeStep === 2 ? true : false}
          isSubmitted={activeStep === 3 ? true : false}
        />

        {/* {activeStep === 0 && (
          <>
            <ProposalGeneratorReview
              edited={false}
              handleGenerateProposal={handleNext}
            />
          </>
        )}
        {activeStep === 1 && (
          <>
            <ProposalGeneratorReview
              edited={false}
              handleGenerateProposal={handleNext}
              isLegal
            />
          </>
        )}
        {activeStep === 2 && (
          <>
            <ProposalGeneratorReview
              // edited={true}
              handleGenerateProposal={handleNext}
              isReview
            />
          </>
        )}
        {activeStep === 3 && (
          <>
            <ProposalGeneratorReview
              edited={false}
              handleGenerateProposal={handleNext}
              // isReview
            />
          </>
        )} */}
      </Box>

      {/* Navigation Buttons */}
      {/* <Box mt={4}>
        <StyledFlexRowView>
          <CommonButton
            variant="outlined"
            onClick={handleBack}
            disabled={activeStep === 0}
            sx={{ mr: 2 }}
            value="Back"
          />
          <CommonButton
            variant="contained"
            onClick={handleNext}
            value={activeStep === steps.length - 1 ? "Generate SoW" : "Next"}
          />
        </StyledFlexRowView>
      </Box> */}

      <IgnitePopup
        activateDialogOpen={hyperDialogOpen.activateOpen}
        title={"Verification Pending !"}
        subTitle={"You have not verified all the information in the Checklist."}
        buttonName={"Ok"}
        handleActivateDialogClose={handleHyperPopupClose}
        icon={<VerificationIco />}
      />

      <SubmitBidPopup
        activateDialogOpen={activate.activateOpen}
        handleActivateDialogClose={handlePopupClose}
      />
    </Box>
  );
}
